import React, { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { AIAssistantSettings } from '../../../../SideBar/SettingsModal/AIAssistantSettings';
import { LocationSettingsSection } from '../../GeneralSection';
import { SETTING_ICONS } from '../../../constants';
import './AIAssistantSection.scss';

const AIAssistantSection: FC = () => {
  const Icon = SETTING_ICONS.ai;
  const { t } = useTranslation();

  return (
    <div className="ai-assistant-section ai-assistant-section--new-tabs">
      <Stack gap={3}>
        <div className="ai-assistant-section__block">
          <Stack gap={1} direction="row" alignItems="center">
            <Icon className="ai-assistant-section__section-icon" />
            <Typography variant="body1" className="ai-assistant-section__section-title">
              {t('settings.nav.aiAssistant')}
            </Typography>
          </Stack>
          <AIAssistantSettings />
        </div>
      </Stack>
    </div>
  );
};

export default AIAssistantSection;
